import { render, staticRenderFns } from "./detail_card_list_row.vue?vue&type=template&id=a4faa9aa&scoped=true"
import script from "./detail_card_list_row.vue?vue&type=script&lang=js"
export * from "./detail_card_list_row.vue?vue&type=script&lang=js"
import style0 from "./detail_card_list_row.vue?vue&type=style&index=0&id=a4faa9aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4faa9aa",
  null
  
)

export default component.exports